import SuccessIcon from 'src/assets/icons/success.svg?react'

import { Flex, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'

type FullScreenMessageProps = {
  title?: string
  content?: string
  type: 'success' | 'error'
}

const icons = {
  success: <SuccessIcon />,
  error: <CloseCircleOutlined className="h-[100px] w-[100px] text-error" />,
}

function FullScreenMessage({ title, content, type }: FullScreenMessageProps) {
  return (
    <Flex vertical className="m-0 min-h-full bg-bg-light p-2.5">
      <Flex
        vertical
        justify="space-between"
        className="m-0 w-full flex-1 rounded-2xl bg-bg-base"
      >
        <Flex vertical align="center" className="max-w-[500px]">
          {icons[type]}
          <Typography.Title
            level={2}
            className="text-center"
            type={type === 'success' ? 'warning' : undefined}
          >
            {title}
          </Typography.Title>
          <Typography.Text className="text-center !text-text-medium">
            {content}
          </Typography.Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default FullScreenMessage
